import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api";

export const apiPainel = axios.create({
  baseURL: API_URL,
});

export default apiPainel;
